import { useLocales } from 'src/locales';

export const useLayoutStyle = () => {
  const { currentLang } = useLocales();

  const isArabic = currentLang?.value === 'ar';

  return isArabic;
};
